import { observable } from 'mobx';
import serviceNames from '~setup/StoresService';
import { ICourierRequest } from '~interfaces/ICourierInterfaces';
import { diContainer } from '~setup/diContainer';
import { CourierRepository } from '~repositories/CourierRepository';

export class CourierQuoteUseCase {
    @observable public courierRepository: CourierRepository;
    @observable public curierRequest: ICourierRequest;

    constructor(curierRequest: ICourierRequest) {
        this.curierRequest = curierRequest;
    }

    public execute = async () => {
        const courierApi = diContainer.get(serviceNames.courierRepository);
        await courierApi.getCourierQuote(this.curierRequest);
    };
}
